/** by MVinfo / Walcledson de Paula 7/6/24w
 * alterações 01/07/24
 * no PC manter o tamanho;
 * no Tablet ou Notebook com telas menores diminuir o tamanho do menu;
 * no celular, deve ficar grudado na parte inferior do celular;
 * 
* src/app/agendexcliente/components/menu/c_menu.jsx
*/

import React, { useState, useEffect, Component } from 'react';
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import imgLogomarca from '../../../../Assets/agendex/logoagendexcliente.png';
import imgLogoMini from '../../../../Assets/agendex/iconLogoAgendex.png';

import Icon from '@mdi/react'; // icone do material design icones pra padronizar o home do mobile/desktop (delphi) no web 2/7/24w
import { mdiHome } from '@mdi/js'; // home
import { mdiLayersSearchOutline } from '@mdi/js'; // pesquisar/explorar empresas
import { mdiCalendarClock } from '@mdi/js'; // agendamentos
import { mdiAccountCircle } from '@mdi/js'; // perfil
import { mdiCogOutline } from '@mdi/js'; // configurações

// *********** explicações de uso dos ícones do "material design icons"
//     <Icon path={mdiHome} size={1} // tamanho do ícone
//     title="Página principal" // hint/dica
//     // size={1}
//     // horizontal // posição (padrão horizontal)
//     // vertical // ficar de cabeça pra baixo (pradão horizontal)
//     // rotate={90} // haverá rotação?
//     // color="red" // claro: cor
//     // spin // se vai ficar girando ou não
//     /> Home 
// *********** explicações de uso dos ícones do "material design icons"


import './menu.css';

function CMenu(props) {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const navigate = useNavigate();

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const activeLink = "nav-link active";
    const inactiveLink = "nav-link text-black";

    function LogoutComponent() {
        localStorage.removeItem("tokenlg");
        localStorage.removeItem("tokenacw");
        localStorage.removeItem("id_categoria");
        localStorage.removeItem("buscaCidade");
    };

    // const handleLogoutClick = () => {
    //     Swal.fire({
    //         title: 'Confirma Logof?',
    //         text: 'Ao fazer logof (sair de sua conta) você será desconectado desta seção. Será necessário fazer Login novamente para ter acesso ao Agendex Web',
    //         icon: 'warning',
    //         showCancelButton: true,
    //         confirmButtonColor: '#3085d6',
    //         cancelButtonColor: '#d33',
    //         confirmButtonText: 'Sim, encerrar!',
    //         cancelButtonText: 'Cancelar'
    //     }).then((result) => {
    //         if (result.isConfirmed) {
    //             LogoutComponent();
    //             navigate('/app/login/cliente');
    //         }
    //     });
    // };

    return (
        <>
            {/* Menu lateral esquerdo para telas maiores */}
            <div className={`d-flex flex-column flex-shrink-0 text-bg-white ${isMobile ? 'd-none' : 'p-3 bg-white'}`} id="menu">
                <a href="/app/cliente/home" className="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none">
                    <img src={isMobile ? imgLogoMini : imgLogomarca} className="img-logo" alt="logo" /><br/>
                </a>
                <p></p>
                <ul className="nav nav-pills flex-column mb-auto">
                    <hr/>
                    <li className="nav-item">
                        <Link to="/app/cliente/home" className={props.page === "home" ? activeLink : inactiveLink} aria-current="page">
                            {/* <i className="bi bi-house"></i><span className="ms-1 d-none d-sm-inline">Home</span> */}
                            <Icon path={mdiHome} size={1} 
                                title="Página principal"
                            /> Home
                        </Link> 
                    </li>
                    <li className="nav-item">
                        <Link to="/app/cliente/home/explorar" className={props.page === "explorar" ? activeLink : inactiveLink} aria-current="page">
                            {/* <i className="bi bi-search"></i><span className="ms-1 d-none d-sm-inline">Explorar</span> */}
                            <Icon path={mdiLayersSearchOutline} size={1} 
                                title="Explorar empresas"/> Explorar
                        </Link>
                    </li>

                    {/* ******* menu agendamentos ******** */}
                    <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            {/* <i className="bi bi-calendar"></i><span className="ms-1 d-none d-sm-inline">Agendamentos</span> */}
                            <Icon path={mdiCalendarClock} size={1}
                                title="ver meus agendamentos (abertos, concluídos, excluídos e pendentes)"/> Agendamentos
                        </a>
                        <ul className="dropdown-menu">
                            <li>
                                <Link to="/app/cliente/agendamentos/abertos" className={props.page === "agendamentosabertos" ? activeLink : inactiveLink} aria-current="page">
                                    <i className="bi bi-calendar2-date-fill"></i> <span className="ms-1 d-none d-sm-inline menu-title">Abertos</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/app/cliente/agendamentos/concluidos" className={props.page === "agendamentosconcluidos" ? activeLink : inactiveLink}>
                                    <i className="bi bi-check2-circle"></i> <span className="ms-1 d-none d-sm-inline menu-title">Concluídos</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/app/cliente/agendamentos/excluidos" className={props.page === "agendamentosexcluidos" ? activeLink : inactiveLink}>
                                    <i className="bi bi-x-circle"></i> <span className="ms-1 d-none d-sm-inline menu-title">Excluídos</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/app/cliente/agendamentos/pendentes" className={props.page === "agendamentospendentes" ? activeLink : inactiveLink}>
                                    <i className="bi bi-clock"></i> <span className="ms-1 d-none d-sm-inline menu-title">Pendentes</span>
                                </Link>
                            </li>
                        </ul>
                    </li>
                    {/* ******* menu agendamentos ******** */}

                    {/* ******* menu configurações ******** */}
                    {/* <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            {/* <i className="bi bi-gear"></i><span className="ms-1 d-none d-sm-inline">Configurações</span> //}
                            <Icon path={mdiCogOutline} size={1}
                                 title="Outras configurações (Fale Conosco e configuração das Notificações Internas)"/> Configurações

                        </a>
                        <ul className="dropdown-menu">
                            <li>
                                <Link to="/app/cliente/config/notificacoes" className={props.page === "notificacoesinternas" ? activeLink : inactiveLink}>
                                    <i className="bi bi-bell-slash"></i>
                                    <span className="ms-1 d-none d-sm-inline">Notificações Internas</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/app/cliente/config/faleconosco" className={props.page === "faleconosco" ? activeLink : inactiveLink}>
                                    <i className="bi bi-chat-dots"></i>
                                    <span className="ms-1 d-none d-sm-inline">Fale Conosco</span>
                                </Link>
                            </li>
                        </ul>
                    </li> */}
                    {/* ******* menu configurações ******** */}

                    {/* ******* menu perfil ******** */}
                    {/* <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            {/* <i className="bi bi-person-circle"></i><span className="ms-1 d-none d-sm-inline">Perfil</span> //}
                            <Icon path={mdiAccountCircle} size={1}
                                title="Meus dados e fazer logof"/> Perfil
                        </a>
                        <ul className="dropdown-menu">
                            <li className="nav-item">
                                <Link to="/app/cliente/perfil" className={props.page === "perfil" ? activeLink : inactiveLink} aria-current="page">
                                    <i className="bi bi-person-lines-fill"></i> <span className="ms-1 d-sm-inline menu-title">Meus Dados</span>
                                </Link>
                            </li>
                            {/* <li className="nav-item">
                                <Link className={props.page === 'perfillogof' ? activeLink : inactiveLink} onClick={handleLogoutClick} aria-current="page">
                                    <i className="bi bi-box-arrow-right"></i> <span className="ms-1 d-sm-inline menu-title">Sair da Conta</span>
                                </Link>
                            </li> //}


                        </ul>
                    </li> */}
                    <li className="nav-item">
                        <Link to="/app/cliente/perfil" className={props.page === "perfil" ? activeLink : inactiveLink} aria-current="page">
                            <Icon path={mdiAccountCircle} size={1} 
                                title="Acessar seus dados pessoais"
                            /> Perfil
                        </Link> 
                    </li>

                    {/* ******* menu perfil ******** */}
                    </ul>
            </div>

            {/* Menu horizontal inferior para dispositivos móveis */}
            {isMobile && (
                <div className="bottom-menu d-flex justify-content-between align-items-center bg-light p-1 fixed-bottom" style={{ height: '50px' }}>
                    {/* Botões do menu horizontal */}
                    <Link to="/app/cliente/home" className={props.page === "home" ? activeLink : inactiveLink}>
                        {/* <i className="bi bi-house"></i>
                        <span className="d-none d-sm-inline">Home</span> */}
                        <Icon path={mdiHome} size={1}/>
                    </Link>
                    <Link to="/app/cliente/home/explorar" className={props.page === "explorar" ? activeLink : inactiveLink}>
                        {/* <i className="bi bi-search"></i>
                        <span className="d-none d-sm-inline">Explorar</span> */}
                        <Icon path={mdiLayersSearchOutline} size={1}/>
                    </Link>

                    {/* ******* menu agendamentos ******** */}
                    <div className="dropdown">
                        <a className={`nav-link dropdown-toggle ${props.page.startsWith("agendamentos") ? activeLink : inactiveLink}`} href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            {/* <i className="bi bi-calendar"></i>
                            <span className="d-none d-sm-inline">Agendamentos</span> */}
                            <Icon path={mdiCalendarClock} size={1}/>
                        </a>
                        <ul className="dropdown-menu">
                            <li>
                                <Link to="/app/cliente/agendamentos/abertos" className={props.page === "agendamentosabertos" ? activeLink : inactiveLink} aria-current="page">
                                    <i className="bi bi-calendar2-date-fill"></i> <span className="ms-1 d-sm-inline menu-title">Abertos</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/app/cliente/agendamentos/concluidos" className={props.page === "agendamentosconcluidos" ? activeLink : inactiveLink}>
                                    <i className="bi bi-check2-circle"></i> <span className="ms-1 d-sm-inline menu-title">Concluídos</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/app/cliente/agendamentos/excluidos" className={props.page === "agendamentosexcluidos" ? activeLink : inactiveLink}>
                                    <i className="bi bi-x-circle"></i> <span className="ms-1 d-sm-inline menu-title">Excluídos</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/app/cliente/agendamentos/pendentes" className={props.page === "agendamentospendentes" ? activeLink : inactiveLink}>
                                    <i className="bi bi-clock"></i> <span className="ms-1 d-sm-inline menu-title">Pendentes</span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                    {/* ******* menu agendamentos ******** */}

                    {/* ******* menu configurações ******** */}
                    {/* <div className="dropdown">
                        <a className={`nav-link dropdown-toggle ${props.page.startsWith("configuracoes") ? activeLink : inactiveLink}`} href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            {/* <i className="bi bi-gear"></i>
                            <span className="d-none d-sm-inline">Configurações</span> //}
                            <Icon path={mdiCogOutline} size={1}/>
                        </a>
                        <ul className="dropdown-menu">
                            <li className="nav-item">
                                <Link to="/app/cliente/config/notificacoes" className={props.page === "notificacoesinternas" ? activeLink : inactiveLink} aria-current="page">
                                    <i className="bi bi-bell-slash"></i> <span className="ms-1 d-sm-inline menu-title">Notificações Internas</span>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/app/cliente/config/faleconosco/" className={props.page === "faleconosco" ? activeLink : inactiveLink} aria-current="page">
                                    <i className="bi bi-chat-dots"></i> <span className="ms-1 d-sm-inline menu-title">Fale Conosco</span>
                                </Link>
                            </li>
                        </ul>
                    </div> */}
                    {/* ******* menu configurações ******** */}

                    {/* ******* menu perfil ******** */}
                    {/* <div className="dropdown">
                        <a className={`nav-link dropdown-toggle ${props.page === "perfil" ? activeLink : inactiveLink}`} href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <i className="bi bi-person-circle"></i>
                        </a>
                        <ul className="dropdown-menu">
                            <li className="nav-item">
                                <Link to="/app/cliente/perfil" className={props.page === "perfil" ? activeLink : inactiveLink} aria-current="page">
                                    <i className="bi bi-person-lines-fill"></i> <span className="ms-1 d-sm-inline menu-title">Meus Dados</span>
                                </Link>
                            </li>
                            {/* <li className="nav-item">
                                <Link className={props.page === 'perfillogof' ? activeLink : inactiveLink} onClick={handleLogoutClick} aria-current="page">
                                    <i className="bi bi-box-arrow-right"></i> <span className="ms-1 d-sm-inline menu-title">Sair da Conta</span>
                                </Link>
                            </li> //}
                        </ul>
                    </div> */}
                    <Link to="/app/cliente/perfil" className={props.page === "perfil" ? activeLink : inactiveLink} aria-current="page">
                        <Icon path={mdiAccountCircle} size={1} 
                            title="Acessar seus dados pessoais"
                        />
                    </Link> 
                    {/* ******* menu perfil ******** */}
                </div>
            )}
        </>
    );
}

export default CMenu;
